export enum AteQuestionType {
  Question = 1,
  ModComment,
  ExpertComment,
  UserComment
}
